<template>
  <v-app-bar class="d-flex justify-center" app flat outlined height="74">
    <v-container style="max-width: 1400px !important; width: 100% !important;"
                 class="d-flex justify-center align-center container--fluid">
      <div class="cursor-pointer" @click="$router.push('/my-parcels/waiting-in-warehouse')">
        <v-img src="/static/images/Logo_PP.svg" height="31px" contain/>
        <h5 style='font-size: 12px; color:var(--text-grey); margin: 0; text-align: right;'>Business</h5>
      </div>
      <v-spacer/>
      <v-btn text @click="logout">logout</v-btn>
    </v-container>
  </v-app-bar>
</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "AppToolbar",
  props: {
    drawer: {type: Boolean}
  },
  components: {},
  data() {
    return {
      trackCode: ""
    };
  },
  methods: {
    ...mapActions(['logout']),
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
  created() {
  }
};
</script>
